<template>
  <div class="game">
    <!-- <div v-if="code != '0' && !loading"
         class="normal">
      <img src="../images/normal.png"
           alt="">
      <p>{{msg}}</p>
    </div> -->
    <Stance
      v-if="code != '0' && !loading"
      type="general"
      :btn-text="btnText"
      :show-info="false"
      :descText="msg"
      @click="btnClick"
      :show-btn="code == '-5' && !loading"
    />
    <div v-if="code != '0' && showBtn && !loading" class="reject-bottom" @click="quit">
      <div class="reject-bottom-button">{{ btnTxt }}</div>
    </div>
    <Skeleton title :row="3" :loading="loading">
      <div v-if="code == '0'" class="form">
        <div class="commit-info">
          <section class="guide-info">
            <div class="main">{{ guideTitle }}</div>
          </section>
          <section class="product-info">
            <div class="title">
              需验货的商品信息
              <span class="productDetial" @click="goToDetial()"> 详情</span>
              <span class="lianjie" @click="goToRadio()" v-if="unableInpspect"
                >无法验货怎么办?</span
              >
            </div>
            <div class="info">
              <div class="pic">
                <div
                  class="pic-core"
                  :style="{ backgroundImage: 'url(' + $setPicSize(info.headImage) + ')' }"
                />
              </div>
              <div class="left-info">
                <div class="left-info-title">
                  商品标题：<span>{{ info.title }}</span>
                </div>
                <div class="left-info-desc">
                  商品描述：<span>{{ info.content }}</span>
                </div>
              </div>
            </div>
          </section>
          <section class="upload-area">
            <div class="title">上传个人信息</div>
            <div class="detial">{{ uploadTitle }}</div>
            <div class="detial">{{ uploadImg }}</div>
            <div class="upload">
              <capture-upload
                img="https://pic3.zhuanstatic.com/zhuanzh/n_v2c063bbf73c3b49cf9c9ddd39f1d54192.png"
                :tip="`请您拍摄本人（${info.name}）手持身份证照片`"
                order="1"
                @uploaded="Uploaded"
              />
            </div>
          </section>

          <!-- 上传凭证 -->
          <section class="basic-info">
            <div class="title">
              上传凭证<span class="process-example" @click="JumpToExample()">查看示例</span>
            </div>
            <div class="detial">{{ uploadphoto }}</div>
            <div class="photo">
              <z-upload
                v-model="pics"
                ref="upload"
                weixin
                :process-file="processFile"
                accept="image/*"
                :max="6"
              />
            </div>
          </section>

          <!-- 事件描述 -->
          <section class="basic-info">
            <div class="title">事件描述</div>
            <div class="item">
              <textarea
                class="desc"
                id="desc"
                maxlength="200"
                ref="textArea"
                @focus="intoAreaView"
                @blur="txtBoxBlur"
                v-model="desc"
                placeholder="可描述您遇到的问题，平台收到后会尽快处理（选填、限200字）"
              ></textarea>
              <span class="desc-length">{{ remainDescLength }}</span>
            </div>
          </section>
        </div>
        <div
          class="form-bottom"
          @click="nextTip()"
          :class="{ 'form-disabled': !canSubmit, 'form-selected': canSubmit }"
        >
          <div class="form-bottom-text">提交审核</div>
        </div>
      </div>
    </Skeleton>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { env } from '@zz-common/zz-utils'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { Stance, Skeleton, Upload } from '@zz-common/zz-ui'
import {
  getcertificationstatus,
  getcloudcheckproduct,
  submitcloudcheck
} from '@api/resourceApi'
import { lego } from '@zz-common/lego'
import { toast } from '../../../native'
import {
  queryParams,
  getCookie,
  getDownAppUrl,
  compareVersion,
  // isZhuanzhuanSeller,
  // isZhuanzhuan,
  tranPics
} from '../../../lib/utils'
  //  TODO
import CaptureUpload from './../CaptureUpload/CaptureUpload'

// import MediaUploadItem from '../MediaUploadItem/MediaUploadItem'
const MAX_DESC_LENGTH = 200
// const MAX_UPLOAD_COUNT = 6
const query = queryParams()

export default {
  name: 'examineInfo',
  data() {
    return {
      infoId: query.infoId || this.$route.query.infoId,
      pid: query.pid || this.$route.query.pid,
      loading: false,
      guideTitle: '请按照提示完成以下商品验证',
      uploadTitle: '*您提供的信息仅用于信息核查，转转保证您的信息安全不被泄露',
      uploadImg: '*请您确保照片清晰，无遮挡，便于识别',
      uploadTrack: '*请上传此商品订单下的有效单号',
      uploadphoto:
          '请上传当前游戏商品的账号信息，建议阅读上方【查看示例】后按要求上传，以免验货失败对您的交易产生影响（至少上传3张，最多6张）',
      cardId: '',
      btnTxt: '确定',
      btnText: '进行实人认证',
      btnLink: '',
      desc: '',
      descLength: 0,
      evidence: [''],
      oneSubmit: true,
      pics: [],
      // action: { target: 'https://upload.58cdn.com.cn/json?rand=0.1928', zz: true },
      down: false, //需要重新下载最新APP
      showBtn: true, //展示图片
      info: {
        source: '',
        infoId: '',
        headImage: '',
        content: '',
        title: '',
        name: '',
        id: ''
      },
      code: '',
      msg: '好像出了点小问题'
    }
  },
  computed: {
    isOpenHarmony() { // 是否为鸿蒙
      return env.$isOpenHarmony && !compareVersion(getCookie('v') || '', '10.30.10')
    },
    pthotoSubmit() {
      return this.evidence.every((item) => item !== '')
    },
    picSubmit() {
      return this.pics.length > 2
    },
    canSubmit() {
      return this.pthotoSubmit && this.picSubmit
    },
    desced() {
      return this.desc.slice(0, 6)
    },
    remainDescLength() {
      return this.desc.length + '/' + MAX_DESC_LENGTH
    },
    unableInpspect() {
      return this.info.source !== '3' && this.info.source !== '4'
    }
  },
  methods: {
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正图片方向修正的问题
        },
        next
      )
    },
    $setPicSize(url) {
      return setPicSize(url, 144, 144)
    },
    init() {
      if (this.isOpenHarmony) {
        this.msg = '当前版本不支持验货，请升级转转APP到最新版本后重试';
        this.code = -1;
        return
      }
      console.log('getCookie(v)', getCookie('v'))
      const appV = native.client
      if (appV === 'zz') {
        if (!compareVersion(getCookie('v') || '', '5.10.0')) {
          this.btnTxt = '下载最新版本'
          this.msg = '请升级最新APP版本后进行云验货'
          this.down = true //下方按钮功能不是关闭页面而是下载app
          return ''
        }
        return this.getcloudcheckproduct()
      }
      if (appV === 'zzseller') {
        return this.getcloudcheckproduct()
      }
      this.msg = '请打开APP后进行云验货'
      this.showBtn = false
    },
    btnClick() {
      this.getcertificationstatus()
    },
    quit() {
      if (this.down) {
        const url = getDownAppUrl()
        if (!url) return toast({ msg: '当前设备不支持下载', style: '2' })
        window.location.href = url
        return ''
      }
      // eslint-disable-next-line eqeqeq
      if (this.code == '-5') {
        // native.skipToUrl({
        //   targetUrl: this.btnLink,
        //   needClose: '0'
        // });
        this.init()
        return ''
      }
      native.close()
    },
    getcertificationstatus() {
      return getcertificationstatus({})
        .then((respData) => {
          // if (respData) return Toast.success('您已成功完成实人认证');
          if (Number(respData)) {
            return toast({ msg: '您已完成实人认证，点击页面下方按钮进入下一步', style: '1' })
          }
          return native.skipToUrl({
            targetUrl: this.btnLink,
            needClose: '0'
          })
        })
        .catch((err) => {
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    getcloudcheckproduct() {
      this.loading = true
      const params = {}
      if (this.infoId) params.infoId = this.infoId
      if (this.pid) params.pid = this.pid
      return getcloudcheckproduct({ ...params })
        .then((respData) => {
          console.log('---respData', respData)
          this.loading = false
          const { code = '', msg = '', data = {}, btnTxt = '', btnLink = '' } = respData
          this.code = code
          this.msg = msg
          this.btnTxt = code !== '-5' ? btnTxt || this.btnTxt : '已完成实人认证'
          if (code === '-5') this.btnText = btnTxt
          this.btnLink = btnLink || this.btnLink
          this.info = { ...data }
          lego.send({
            pagetype: 'ZZUP_CLOUDINSPECTION',
            actiontype: 'PAGE_SHOW',
            backup: {
              source: this.info.source
            }
          })
          console.log('---this.code', this.code)
          console.log('---this.msg', this.msg)
          console.log('---this.info', this.info)
          return respData
        })
        .catch((err) => {
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    nextTip() {
      if (!this.pthotoSubmit) return toast({ msg: '请拍摄照片后再提交', style: '2' })
      if (!this.picSubmit) return toast({ msg: '请至少上传三张凭证', style: '2' })
      if (!this.canSubmit) return ''
      if (!this.oneSubmit) return '' //防止多次重复提交
      this.oneSubmit = false
      this.submit()
    },
    JumpToExample() {
      this.$router.push({
        path: 'uploadExample'
      })
    },
    goToDetial() {
      native.wrap('enterDetail')({
        infoId: this.info.infoId,
        from: 'm'
      })
    },
    goToRadio() {
      //toast({ msg: '提交成功', style: '2' });
      // native.skipToUrl({
      //   targetUrl: `https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=CloudInspectionPushUnResult&id=${this.info.id}&infoId=${this.info.infoId}&name=${this.info.name}`,
      //   needClose: '1'
      // });
      const queries = {
        id: this.info.id,
        infoId: this.info.infoId,
        name: this.info.name
      }
      this.$router.push({
        path: 'UnableInspect',
        query: queries
      })
    },
    Uploaded(rst, startTime, order) {
      this.evidence.splice(order - 1, 1, rst)
      this.evidence.map((item) => console.log('img', item))
    },
    txtBoxBlur() {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight
      }, 100)
    },
    intoAreaView() {
      console.log('textArea focous----')
      console.log('this.$refs.textArea----', this.$refs.textArea)
      setTimeout(() => {
        this.$refs.textArea.scrollIntoView()
      }, 300)
    },
    submit() {
      const params = {
        id: this.info.id,
        checkType: '0',
        infoId: this.info.infoId,
        reason: this.desc,
        evidence: [...this.evidence, ...tranPics(this.pics)].join('|')
      }
      submitcloudcheck(params)
        .then((res) => {
          const { code = '', msg = '提交失败' } = res
          if (code !== '0') {
            this.oneSubmit = true //接口返回值 可以再次提交
            return toast({ msg, style: '2' })
          }
          toast({ msg: '提交成功', style: '2' })
          //  提交成功后 2s 关闭页面
          setTimeout(() => {
            native.skipToUrl({
              targetUrl: `https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=CloudInspectionPushResult&infoId=${this.info.infoId}`,
              needClose: '1'
            })
          }, 500)
        })
        .catch((err) => {
          //  失败
          this.oneSubmit = true //接口返回值 可以再次提交
          toast({
            msg: err.errMsg || err || '提交失败',
            style: '2'
          })
          console.error(err)
        })
    }
  },
  mounted() {
    native.setTitle({
      title: '在线验货'
    })
    // this.submit = debounce(this.submit, 2000, false);
    this.init()
    console.log('-------this.from', this.from)
    native.wrap('setKeyboardFrameChangeCallback')((res) => {
      if (!res.kbState) return
      if (res.kbState === '1') {
        console.log('-------输入键盘出现')
      } else {
        console.log('-------输入键盘消失')
        if (this.$refs.input) this.$refs.input.blur()
        if (this.$refs.textArea) this.$refs.textArea.blur()
      }
    })
  },
  components: {
    Skeleton,
    Stance,
    CaptureUpload,
    zUpload: Upload
  }
}
</script>

<style lang="less">
  @import 'GameExamine.less';
</style>
